// extracted by mini-css-extract-plugin
export default {"modalContainer":"Modal_modalContainer__tSHvO","modalPanel":"Modal_modalPanel__PtsTv"};